/** Admin environment (04-architecture § 5.1). `/meta` wins over these at runtime. */
import { z } from 'zod';

const EnvSchema = z.object({
  APP_ENV: z.enum(['production', 'staging', 'development', 'e2e']).default('development'),
  APP_VERSION: z.string().default('dev'),
  API_BASE_URL: z.string().url(),
  SITE_URL: z.string().url(),
  MEMBER_URL: z.string().url(),
  ADMIN_URL: z.string().url(),
  OTTER_PUBLISHABLE_KEY: z.string().optional(),
  SENTRY_DSN: z.string().optional(),
});

export const env = EnvSchema.parse({
  APP_ENV: import.meta.env.VITE_APP_ENV,
  APP_VERSION: import.meta.env.VITE_APP_VERSION,
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  SITE_URL: import.meta.env.VITE_SITE_URL,
  MEMBER_URL: import.meta.env.VITE_MEMBER_URL,
  ADMIN_URL: import.meta.env.VITE_ADMIN_URL,
  OTTER_PUBLISHABLE_KEY: import.meta.env.VITE_OTTER_PUBLISHABLE_KEY,
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
});
